// extracted by mini-css-extract-plugin
export var mediaTextTeaserContainer = "ContentTeaserMediaText-module--mediaTextTeaserContainer--de4df";
export var tagline = "ContentTeaserMediaText-module--tagline--05a46";
export var teaserContent = "ContentTeaserMediaText-module--teaserContent--5a335";
export var teaserOne = "ContentTeaserMediaText-module--teaserOne--9839d";
export var teaserTwo = "ContentTeaserMediaText-module--teaserTwo--3abf9";